import React from "react";

export default function ManageSubscriptions({ onClose, onSave }) {



  return (
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title">Manage subscription</h5>
        <button type="button" className="btn-close" onClick={onClose}></button>
      </div>

      <div className="modal-body">
        <p className="mb-3">
          All payments for this website are handled by Stripe. You can manage your
          subscription through the Stripe portal.
        </p>

        <p className="fw-bold mb-2">In the Stripe portal you can:</p>
        <ul className="mb-3">
          <li>Update your card or payment method</li>
          <li>View your billing history</li>
          <li>Download invoices and receipts</li>
          <li>Update your billing information</li>
          <li>Cancel the subscription at the end of the period</li>
        </ul>

        <button
          className="btn brand-purple-inline text-white w-100"
          onClick={(e) => onSave()}
        >
          Open Stripe portal
        </button>
      </div>

      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
}
